import Router from 'vue-router'

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
      		name: 'home',
			component: () => import('../Main.vue')
		},
		{
			path: '/detail/:id', 
			name: 'detail',
			component: () => import('../pages/Detail.vue')
		},
	]
})

export default router